/* Obsessed Haircare — Shopify theme JS
   Handles: FAQ accordion, PDP gallery, variant picker (updates hidden input +
   price), qty steppers, mobile drawer, scroll-reveal. Uses vanilla JS. */
(function(){
  'use strict';

  // ---- Scroll reveal -----------------------------------------------------
  // Fires as soon as ANY pixel of the element enters the viewport (with a generous
  // top/bottom buffer), so tall sections and slow scrolls reveal reliably.
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '200px 0px 200px 0px' });
    document.querySelectorAll('.rise').forEach(function(el){ io.observe(el); });
  } else {
    document.querySelectorAll('.rise').forEach(function(el){ el.classList.add('in'); });
  }
  // Failsafe: anything still hidden after 2s gets revealed so the page never
  // shows blank gaps if the observer misfires (page swaps, prefetch, etc.).
  setTimeout(function(){
    document.querySelectorAll('.rise:not(.in)').forEach(function(el){ el.classList.add('in'); });
  }, 2000);

  // ---- FAQ accordion -----------------------------------------------------
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.faq-q');
    if (!btn) return;
    var item = btn.closest('.faq-item');
    var open = item.classList.toggle('open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    // close siblings
    if (open) {
      item.parentElement.querySelectorAll('.faq-item.open').forEach(function(sib){
        if (sib !== item) {
          sib.classList.remove('open');
          var sq = sib.querySelector('.faq-q');
          if (sq) sq.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });

  // ---- PDP thumbnail gallery ---------------------------------------------
  var mainImg = document.getElementById('PdpMainImg');
  document.querySelectorAll('.pdp-thumb').forEach(function(thumb){
    thumb.addEventListener('click', function(){
      if (!mainImg) return;
      var full = thumb.getAttribute('data-full');
      if (full) mainImg.src = full;
      document.querySelectorAll('.pdp-thumb').forEach(function(t){ t.classList.remove('active'); });
      thumb.classList.add('active');
    });
  });

  // ---- PDP variant picker ------------------------------------------------
  document.querySelectorAll('.pdp-variants input[name="id"]').forEach(function(radio){
    radio.addEventListener('change', function(){
      if (!radio.checked) return;
      var pill = radio.closest('.variant-pill');
      document.querySelectorAll('.variant-pill').forEach(function(p){ p.classList.remove('active'); });
      if (pill) pill.classList.add('active');
      var price = radio.getAttribute('data-price');
      var img = radio.getAttribute('data-image');
      if (price) {
        var p1 = document.getElementById('PdpPrice'); if (p1) p1.textContent = price;
        var p2 = document.getElementById('PdpBtnPrice'); if (p2) p2.textContent = price;
      }
      if (img && mainImg) mainImg.src = img;
    });
  });

  // ---- Quantity steppers -------------------------------------------------
  document.addEventListener('click', function(e){
    var minus = e.target.closest('[data-qty-minus]');
    var plus  = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var wrap = (minus || plus).closest('.qty-step');
    if (!wrap) return;
    var input = wrap.querySelector('input[type="number"]') || wrap.querySelector('span');
    if (!input) return;
    var current = parseInt((input.value !== undefined ? input.value : input.textContent) || '1', 10);
    if (isNaN(current)) current = 1;
    current = minus ? Math.max(1, current - 1) : current + 1;
    if (input.value !== undefined) {
      input.value = current;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      input.textContent = current;
    }
  });

  // ---- Mobile drawer -----------------------------------------------------
  var drawer  = document.getElementById('mobile-drawer');
  var overlay = document.querySelector('.drawer-overlay');
  document.querySelectorAll('[data-drawer-open]').forEach(function(btn){
    btn.addEventListener('click', function(){
      if (drawer)  drawer.classList.add('open');
      if (overlay) overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  });
  document.querySelectorAll('[data-drawer-close]').forEach(function(btn){
    btn.addEventListener('click', function(){
      if (drawer)  drawer.classList.remove('open');
      if (overlay) overlay.classList.remove('open');
      document.body.style.overflow = '';
    });
  });

})();